import { render, staticRenderFns } from "./TemplateZones.vue?vue&type=template&id=c7086082&scoped=true&"
import script from "./TemplateZones.vue?vue&type=script&lang=js&"
export * from "./TemplateZones.vue?vue&type=script&lang=js&"
import style0 from "./TemplateZones.vue?vue&type=style&index=0&id=c7086082&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7086082",
  null
  
)

export default component.exports